import { Facebook, Instagram, Twitter, Youtube } from "lucide-react";
import { Link } from "react-router-dom";

const Footer = () => {
  return (
    <footer className="bg-card border-t border-border py-12">
      <div className="container mx-auto px-4">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8 mb-8">
          {/* Brand */}
          <div>
            <div className="flex items-center space-x-2 mb-4">
              <div className="w-10 h-10 bg-gradient-primary rounded-lg flex items-center justify-center">
                <span className="text-2xl font-bold text-primary-foreground">B</span>
              </div>
              <span className="text-xl font-bold bg-gradient-primary bg-clip-text text-transparent">
                BetPro
              </span>
            </div>
            <p className="text-sm text-muted-foreground mb-4">
              A plataforma de apostas online mais confiável do Brasil. Aposte com responsabilidade.
            </p>
            <div className="flex space-x-4">
              <a href="https://facebook.com" target="_blank" rel="noopener noreferrer" className="text-muted-foreground hover:text-primary transition-colors">
                <Facebook className="w-5 h-5" />
              </a>
              <a href="https://instagram.com" target="_blank" rel="noopener noreferrer" className="text-muted-foreground hover:text-primary transition-colors">
                <Instagram className="w-5 h-5" />
              </a>
              <a href="https://twitter.com" target="_blank" rel="noopener noreferrer" className="text-muted-foreground hover:text-primary transition-colors">
                <Twitter className="w-5 h-5" />
              </a>
              <a href="https://youtube.com" target="_blank" rel="noopener noreferrer" className="text-muted-foreground hover:text-primary transition-colors">
                <Youtube className="w-5 h-5" />
              </a>
            </div>
          </div>

          {/* Jogos */}
          <div>
            <h3 className="text-foreground font-semibold mb-4">Jogos</h3>
            <ul className="space-y-2">
              <li>
                <Link to="/sports" className="text-muted-foreground hover:text-primary transition-colors text-sm">
                  Apostas Esportivas
                </Link>
              </li>
              <li>
                <Link to="/casino" className="text-muted-foreground hover:text-primary transition-colors text-sm">
                  Cassino Online
                </Link>
              </li>
              <li>
                <Link to="/live-casino" className="text-muted-foreground hover:text-primary transition-colors text-sm">
                  Cassino ao Vivo
                </Link>
              </li>
              <li>
                <Link to="/crash-games" className="text-muted-foreground hover:text-primary transition-colors text-sm">
                  Jogos Rápidos
                </Link>
              </li>
            </ul>
          </div>

          {/* Suporte */}
          <div>
            <h3 className="text-foreground font-semibold mb-4">Suporte</h3>
            <ul className="space-y-2">
              <li>
                <Link to="/help-center" className="text-muted-foreground hover:text-primary transition-colors text-sm">
                  Central de Ajuda
                </Link>
              </li>
              <li>
                <Link to="/how-to-deposit" className="text-muted-foreground hover:text-primary transition-colors text-sm">
                  Como Depositar
                </Link>
              </li>
              <li>
                <Link to="/how-to-withdraw" className="text-muted-foreground hover:text-primary transition-colors text-sm">
                  Como Sacar
                </Link>
              </li>
              <li>
                <Link to="/responsible-gaming" className="text-muted-foreground hover:text-primary transition-colors text-sm">
                  Jogo Responsável
                </Link>
              </li>
            </ul>
          </div>

          {/* Legal */}
          <div>
            <h3 className="text-foreground font-semibold mb-4">Legal</h3>
            <ul className="space-y-2">
              <li>
                <Link to="/terms" className="text-muted-foreground hover:text-primary transition-colors text-sm">
                  Termos de Uso
                </Link>
              </li>
              <li>
                <Link to="/privacy" className="text-muted-foreground hover:text-primary transition-colors text-sm">
                  Política de Privacidade
                </Link>
              </li>
              <li>
                <Link to="/rules" className="text-muted-foreground hover:text-primary transition-colors text-sm">
                  Regras e Regulamentos
                </Link>
              </li>
              <li>
                <Link to="/licenses" className="text-muted-foreground hover:text-primary transition-colors text-sm">
                  Licenças
                </Link>
              </li>
            </ul>
          </div>
        </div>

        {/* Bottom Bar */}
        <div className="border-t border-border pt-8">
          <div className="flex flex-col md:flex-row justify-between items-center space-y-4 md:space-y-0">
            <p className="text-sm text-muted-foreground">
              © 2025 BetPro. Todos os direitos reservados.
            </p>
            <div className="flex items-center space-x-4">
              <img src="https://upload.wikimedia.org/wikipedia/commons/0/04/Visa.svg" alt="Visa" className="h-6 opacity-70" />
              <img src="https://upload.wikimedia.org/wikipedia/commons/2/2a/Mastercard-logo.svg" alt="Mastercard" className="h-6 opacity-70" />
              <img src="https://upload.wikimedia.org/wikipedia/commons/b/b5/PayPal.svg" alt="PayPal" className="h-6 opacity-70" />
            </div>
          </div>
          <p className="text-xs text-muted-foreground mt-4 text-center md:text-left">
            Jogue com responsabilidade. +18. Apostas podem causar dependência.
          </p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;